module.exports = __webpack_public_path__ + "static/media/single.77dc9c34.svg";